import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Label } from '@phoenix/design-system/frontend/ui/form';
import { Hint } from '@phoenix/design-system/frontend/ui/form/hint';
import { StarRating } from '../../star-rating/star-rating';

interface HookFormStarRatingProps {
  label: string;
  name: string;
  className?: string;
  required?: boolean;
}

export const HookFormStarRating: FC<HookFormStarRatingProps> = ({ label, name, className = 'mt-4', required = false }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={{ required }}
      render={({ field: { value, onChange } }) => (
        <div className={className}>
          <Label text={label} />
          <StarRating
            className="mt-2"
            value={value}
            starSize={6}
            onSelect={onChange}
            iconClassName={errors[name] ? 'text-red' : 'text-secondary-dark'}
          >
            <span className="stihl-text-body-sm-reg">{value}</span>
          </StarRating>
          {errors[name] && <Hint type="error" message={errors[name]?.message} />}
        </div>
      )}
    />
  );
};
